module.exports = "<svg tabindex='-1' viewBox=\"0 0 24 24\"><path d=\"M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./app/assets/icon-right-arrow.svg
// module id = 741
// module chunks = 0